import React from 'react';
import { Box, Button, IconButton, TextField } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const pad = n => String(n).padStart(2, '0');
const toDateStr = d => `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
const parseLocal = str => { const [y,m,d] = str.split('-').map(Number); return new Date(y, m-1, d); };

function ReportPeriodPicker({ dateFrom, dateTo, periodMode, onDateFromChange, onDateToChange, onPeriodModeChange }) {
  const shiftDays = (delta) => {
    const f = parseLocal(dateFrom); f.setDate(f.getDate() + delta);
    const t = parseLocal(dateTo);   t.setDate(t.getDate() + delta);
    onDateFromChange(toDateStr(f));
    onDateToChange(toDateStr(t));
  };

  const shiftMonths = (delta) => {
    const [year, month] = dateFrom.split('-').map(Number);
    const d = new Date(year, month - 1 + delta, 1);
    onDateFromChange(toDateStr(new Date(d.getFullYear(), d.getMonth(), 1)));
    onDateToChange(toDateStr(new Date(d.getFullYear(), d.getMonth() + 1, 0)));
  };

  const handlePrev = () => {
    if (periodMode === 'month') { shiftMonths(-1); return; }
    const days = periodMode === 'week' ? -7 : -(Math.round((parseLocal(dateTo) - parseLocal(dateFrom)) / 86400000) + 1);
    shiftDays(days);
  };

  const handleNext = () => {
    if (periodMode === 'month') { shiftMonths(1); return; }
    const days = periodMode === 'week' ? 7 : Math.round((parseLocal(dateTo) - parseLocal(dateFrom)) / 86400000) + 1;
    shiftDays(days);
  };

  const setThisDay =() =>{
    const d = new Date();
    onDateFromChange(toDateStr(d))
    onDateToChange(toDateStr(d))
    onPeriodModeChange('day');
  }

  const setThisWeek = () => {
    const d = new Date();
    const day = d.getDay() || 7;
    const mon = new Date(d.getFullYear(), d.getMonth(), d.getDate() - day + 1);
    const sun = new Date(mon.getFullYear(), mon.getMonth(), mon.getDate() + 6);
    onDateFromChange(toDateStr(mon));
    onDateToChange(toDateStr(sun));
    onPeriodModeChange('week');
  };

  const setThisMonth = () => {
    const d = new Date();
    onDateFromChange(toDateStr(new Date(d.getFullYear(), d.getMonth(), 1)));
    onDateToChange(toDateStr(new Date(d.getFullYear(), d.getMonth() + 1, 0)));
    onPeriodModeChange('month');
  };

  return (
    <Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, justifyContent: 'center' }}>
        <Button variant={periodMode === 'day' ? 'contained' : 'outlined'} size="small" onClick={setThisDay}>Ten dzień</Button>
        <Button variant={periodMode === 'week' ? 'contained' : 'outlined'} size="small" onClick={setThisWeek}>Ten tydzień</Button>
        <Button variant={periodMode === 'month' ? 'contained' : 'outlined'} size="small" onClick={setThisMonth}>Ten miesiąc</Button>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 2 }}>
        <IconButton size="small" onClick={handlePrev}><ChevronLeftIcon /></IconButton>
        <TextField
          label="Od" type="date" size="small" value={dateFrom}
          onChange={e => { onDateFromChange(e.target.value); onPeriodModeChange('custom'); }}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="Do" type="date" size="small" value={dateTo}
          onChange={e => { onDateToChange(e.target.value); onPeriodModeChange('custom'); }}
          InputLabelProps={{ shrink: true }}
        />
        <IconButton size="small" onClick={handleNext}><ChevronRightIcon /></IconButton>
      </Box>
    </Box>
  );
}

export default ReportPeriodPicker;
